/**
 * Formats an array of error messages with proper capitalization and punctuation.
 * Only the first message starts with a capital letter, all other messages start with lowercase.
 * Messages are joined with a comma and space.
 */
const formatErrorMessages = (messages: (string | undefined)[]): string => {
  const filteredMessages = messages.filter(Boolean) as string[];

  if (filteredMessages.length === 0) return '';

  return filteredMessages
    .map((message, index) => {
      // Keep first message as is, lowercase the first letter of subsequent messages
      return index === 0 ? message : message.charAt(0).toLowerCase() + message.slice(1);
    })
    .join(', ');
};

export { formatErrorMessages };
